<img *ngIf="customPath && useCustom" [src]="customPath" [alt]="icon" class="service-custom-icon"
  referrerpolicy="no-referrer" (error)="onError()">
<i *ngIf="!customPath || !useCustom" class="fas fa-{{icon}}"></i>
